import PropTypes from "prop-types";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// Materials
import { Stack } from "@mui/material";

// Constants
const regularInputMax = 9999;

const getDecimalPrecision = ({ finance = false, crossStore = false }) => {
	if (finance) {
		return 2;
	}
	return crossStore ? 1 : 0;
};

const getDeltaPrecision = ({ finance = false, crossStore = false }) => (finance || !crossStore ? 0.01 : 0.5);

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		errors = [],
		backendProductsCount = 7,
		fromDisabled = false,
		toDisabled = false,
		crossStore = false,
		finance = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	const maxInputValue = finance ? backendProductsCount : regularInputMax;
	const delta = getDeltaPrecision({ finance, crossStore });
	const decimals = getDecimalPrecision({ finance, crossStore });
	const decimalsEditable = Boolean(finance || crossStore);

	const inputDefinition = {
		type: "Unit",
		min: 0,
		max: maxInputValue,
		delta,
		decimals,
		decimalsEditable,
	};

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [{ ...inputDefinition, dashed: fromDisabled }],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Unit",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [{ ...inputDefinition, dashed: toDisabled }],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Unit",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	errors: PropTypes.array,
	backendProductsCount: PropTypes.number,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	crossStore: PropTypes.bool,
	finance: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
